import credit from '../img/parts/ネモ誕2024クレジット.png'
import うめにてー from '../img/parts/hokuro/六等分ネモた_うめにてー.png'
import カタチ from '../img/parts/hokuro/六等分ネモた_カタチのないもの.png'
import シクナイ from '../img/parts/hokuro/六等分ネモた_シクナイ.png'
import 夏祭り from '../img/parts/hokuro/六等分ネモた_夏祭り.png'
import 初期 from '../img/parts/hokuro/六等分ネモた_初期衣装.png'
import 新衣装 from '../img/parts/hokuro/六等分ネモた_新衣装.png'
import msgBtn from '../img/parts/button/massageBtn.png'
import illustBtn from '../img/parts/button/illustBtn.png'
import illustBtn_2 from '../img/parts/button/illustBtn_2.png'
import eventBtn from '../img/parts/button/eventBtn.png'
import hokuroBtn from '../img/parts/button/hokuroBtn.png'
import logo_3_blue from '../img/parts/logo/logo_3_blue.png'
import logo_3_red from '../img/parts/logo/logo_3_red.png'
import start_pc from '../img/parts/start_pc.png'
import start_phone from '../img/parts/start_phone.png'
import メッセージ台紙 from '../img/parts/メッセージ台紙.png'
import gif1 from '../img/parts/gif/GIFUMenity.gif'
import gif2 from '../img/parts/gif/GIF新衣装.gif'
import gif3 from '../img/parts/gif/GIFシクナイ.gif'
import gif4 from '../img/parts/gif/GIF夏祭り.gif'
import gif5 from '../img/parts/gif/GIFカタチのないもの.gif'
import gif6 from '../img/parts/gif/GIF初期衣装.gif'
import aniBg1 from '../img/parts/anime_bg/ネモ誕アニメ_背景_1.png'
import aniBg2 from '../img/parts/anime_bg/ネモ誕アニメ_背景_2.png'
import aniBg3 from '../img/parts/anime_bg/ネモ誕アニメ_背景_3.png'
import start_bg from '../img/parts/start_bg.png'
import favicon from '../img/parts/favicon.png'

export function hokuroImage() {
  const IllustBox = [
    credit,
    メッセージ台紙,
    start_pc,
    start_phone,
    うめにてー,
    gif1,
    新衣装,
    gif2,
    シクナイ,
    gif3,
    夏祭り,
    gif4,
    カタチ,
    gif5,
    初期,
    gif6,
    start_bg,
    favicon,
    msgBtn,
    illustBtn,
    illustBtn_2,
    eventBtn,
    hokuroBtn,
    logo_3_blue,
    logo_3_red,
    aniBg1,
    aniBg2,
    aniBg3,
  ]
  return IllustBox
}
export default hokuroImage
